/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuditResponse,
  CompanyRequest,
  CompanyRequestDataWithFiles,
  CompanyRequestFiles,
  CompanyResponse,
  PageResponseCompanyResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Companies<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags company-controller
   * @name AddCompany
   * @request POST:/companies
   * @secure
   * @response `200` `CompanyResponse` OK
   */
  addCompany = (
    data: CompanyRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CompanyResponse, any>({
      path: `/companies`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags company-controller
   * @name AllCompanies
   * @request POST:/companies/getCompanies
   * @secure
   * @response `200` `PageResponseCompanyResponse` OK
   */
  allCompanies = (data: CompanyRequest, params: RequestParams = {}) =>
    this.request<PageResponseCompanyResponse, any>({
      path: `/companies/getCompanies`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags company-controller
   * @name GetCompanyById
   * @summary Get Company by ID
   * @request GET:/companies/{companyId}
   * @secure
   * @response `200` `CompanyResponse` OK
   */
  getCompanyById = (companyId: string, params: RequestParams = {}) =>
    this.request<CompanyResponse, any>({
      path: `/companies/${companyId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags company-controller
   * @name DeleteCompany
   * @request DELETE:/companies/{companyId}
   * @secure
   * @response `200` `CompanyResponse` OK
   */
  deleteCompany = (companyId: string, params: RequestParams = {}) =>
    this.request<CompanyResponse, any>({
      path: `/companies/${companyId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags company-controller
   * @name UpdateCompany
   * @request PATCH:/companies/{companyId}
   * @secure
   * @response `200` `CompanyResponse` OK
   */
  updateCompany = (
    companyId: string,
    data: CompanyRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CompanyResponse, any>({
      path: `/companies/${companyId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags company-controller
   * @name DownloadCompanyDocuments
   * @summary Download Company Documents
   * @request GET:/companies/{companyId}/documents
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadCompanyDocuments = (companyId: string, params: RequestParams = {}) =>
    this.request<Blob, any>({
      path: `/companies/${companyId}/documents`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags company-controller
   * @name UpdateCompanyDocuments
   * @request PATCH:/companies/{companyId}/documents
   * @secure
   * @response `200` `CompanyResponse` OK
   */
  updateCompanyDocuments = (
    companyId: string,
    query: {
      request: CompanyRequestFiles;
    },
    params: RequestParams = {},
  ) =>
    this.request<CompanyResponse, any>({
      path: `/companies/${companyId}/documents`,
      method: "PATCH",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags company-controller
   * @name DownloadCompanyDocument
   * @summary Download Company Document
   * @request GET:/companies/{companyId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadCompanyDocument = (
    companyId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/companies/${companyId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags company-controller
   * @name DeleteCompanyDocument
   * @summary Delete Company Document
   * @request DELETE:/companies/{companyId}/documents/{documentId}
   * @secure
   * @response `200` `CompanyResponse` OK
   */
  deleteCompanyDocument = (
    companyId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<CompanyResponse, any>({
      path: `/companies/${companyId}/documents/${documentId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags company-controller
   * @name GetHistory4
   * @request GET:/companies/history/{resourceId}
   * @secure
   * @response `200` `(AuditResponse)[]` OK
   */
  getHistory4 = (resourceId: string, params: RequestParams = {}) =>
    this.request<AuditResponse[], any>({
      path: `/companies/history/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
